/* eslint-disable react/no-danger */
import React, { useCallback, useEffect, useState } from 'react';
import { HiCheck } from 'react-icons/hi';

import { Container, CheckboxInput, Error } from './styles';
import Input from '../Input';

export interface IOption {
  value: string | number;
  label: string;
  selected?: boolean;
  labelHtml?: boolean;
}

interface IInputCheckbox {
  type: 'checkbox' | 'radio';
  name: string;
  options: IOption[];
  className?: string;
  onChange?(options: IOption[]): void;
  error?: string;
  labelHtml?: boolean;
}

const InputCheckbox: React.FC<IInputCheckbox> = ({
  type,
  name,
  options,
  className,
  onChange,
  error,
  labelHtml,
}) => {
  const [data, setData] = useState<IOption[]>([]);

  useEffect(() => {
    setData(options);
  }, [options]);

  const handleChange = useCallback(
    (option) => {
      let newData = data.slice();
      const dataIndex = newData.findIndex(
        (optionData) => optionData.value === option.value
      );
      if (dataIndex >= 0) {
        if (type === 'radio') {
          newData = newData.map((optionData) => ({
            ...optionData,
            selected: optionData === option,
          }));
        } else {
          newData[dataIndex].selected = !newData[dataIndex].selected;
        }
        setData(newData);
      }
      if (onChange) {
        onChange(newData);
      }
    },
    [data, onChange, type]
  );

  return (
    <>
      <Container className={className}>
        {data.map((option, index) => (
          <CheckboxInput
            key={index}
            htmlFor={`${name}_${index}`}
            selected={option.selected}
          >
            <div>
              {option.selected && (
                <HiCheck size={16} color="#fff" className="check-icon" />
              )}
            </div>
            <input
              type={type}
              id={`${name}_${index}`}
              name={type === 'checkbox' ? `${name}_checkbox` : name}
              value={option.value}
              onChange={() => handleChange(option)}
              className="inputData"
              checked={option.selected}
            />
            {labelHtml || option.labelHtml ? (
              <span dangerouslySetInnerHTML={{ __html: option.label }} />
            ) : (
              <span>{option.label}</span>
            )}
          </CheckboxInput>
        ))}
      </Container>
      <Input
        type="hidden"
        name={name}
        className="d-none"
        value={options.find((option) => option.selected)?.value}
      />
      {error && <Error className="small text-danger error">{error}</Error>}
    </>
  );
};

export default InputCheckbox;
